<template>
  <div>
    <Header :title="title"/>
    <div class="footer_podat" v-if="god">
       <div class="main">
        <div align="center"><button class="btns" @click="dale()">Далее</button></div>
       </div>
    </div>

    <div class="content_podat">
      <div v-for="g in arr" :key="g.god" class="block_radio">
        <input
          class="custom-radio"
          name="color"
          v-model="god"
          type="radio"
          :id="g.god"
          :value="g.god"
          @change="select"
        />
        <label :for="g.god">{{g.god}}</label>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/headerpodat'
export default {
   components:{
   Header
   },
  data() {
    return {
      title:"Выберите год выпуска",
      god: "",
       arr: [
        {god: 2025},{god: 2024},{god: 2023},{god: 2022},{god: 2021},{god: 2020},{god: 2019},{god: 2018},{god: 2017},
        {god: 2016},{god: 2015},{god: 2014},{god: 2013},{god: 2012},{god: 2011},
        {god: 2010},{god: 2009},{god: 2008},{god: 2007},{god: 2006},{god: 2005},
        {god: 2004},{god: 2003},{god: 2002},{god: 2001},{god: 2000},{god: 1999},
        {god: 1998},{god: 1997},{god: 1996},{god: 1995},{god: 1994},{god: 1993},
        {god: 1992},{god: 1991},{god: 1990},{god: 1989},{god: 1988},{god: 1987},
        {god: 1986},{god: 1985},{god: 1984},{god: 1983},{god: 1982},{god: 1981},
        {god: 1980},{god: 1979},{god: 1978},{god: 1977},{god: 1976},{god: 1975},
        {god: 1974},{god: 1973},{god: 1972},{god: 1971},{god: 1970},{god: 1969},
        {god: 1968},{god: 1967},{god: 1966},{god: 1965},{god: 1964},{god: 1963},
        {god: 1962},{god: 1961},{god: 1960},{god: 1959},{god: 1958},{god: 1957},
        {god: 1956},{god: 1955},{god: 1954},{god: 1953},{god: 1952},{god: 1951},
        {god: 1950},
      ],
    };
  },
  methods: {
    select() {
        this.$store.commit("addpodatgod",this.god);
        this.dale();

    },
    dale() {
    if(this.getkateg=="avto") this.$router.push({ name: "kuzov" });
    else if(this.getkateg=="gruzspes") this.$router.push({ name: "topliva" });
    else this.$router.push({ name: "info" });  
    },
  },
  computed: {
    getgod() {
      return this.$store.getters.getpodatgod;
    },
     getkateg() {
      return this.$store.getters.getpodatkateg;
    },
   },
  created() {
    if (!localStorage.getItem("token")) {
       this.$router.go(-1); 
      } 
  },
  mounted (){
    if(this.getgod){
      this.god=this.getgod;
    }
  }
};
</script>
<style scoped>
.block_radio {
  margin-bottom: 1.4em;
}
.divgorod {
  width: 100%;
  color: #777777;
}
.contentgorod {
  font-size: 20px;
  border-bottom: 1px solid #000000;
  padding: 5px 5px 5px 0px;
}
label {
  font-size: 18px;
  width: 100%;
}
.content_podat {
  padding: 90px 5px 65px 10px;
}
</style>